import React from 'react'
import { KTSVG } from '../../helpers/KTSVG'
function ButtonPage() {
  return (
    <div class="d-flex flex-row h-600px">
    <div class="d-flex flex-column flex-row-auto w-200px">
        <div class="d-flex flex-column-auto h-50px bg-primary">
            <span class="text-white">Fixed Height</span>
        </div>

        <div class="d-flex flex-column-fluid bg-success flex-center" style={{position:"fixed",top:0,left:0,bottom:0}}>
            <span class="text-white">Fluid Height</span>
        </div>
    </div>

    <div class="d-flex flex-column flex-row-fluid">
        <div class="d-flex flex-column-auto h-70px bg-info flex-center">
            <span class="text-white">Fixed Height</span>
        </div>

        <div class="d-flex flex-row flex-column-fluid">
            <div class="d-flex flex-row-fluid bg-dark flex-center">
                <span class="text-white">Fluid Width</span>
            </div>

           
        </div>
    </div>
</div>


  )
}

export default ButtonPage